<template>
  <div>
    <basic-container>
      <div style="height: 20px"></div>
      <el-form :inline="true" ref="form" :model="form">
        <el-row>
          <el-col span="6">
            <el-form-item
              label="项目名称"
              prop="projectId"
              :rules="[{ required: true, message: '请选择项目', trigger: 'blur' }]"
            >
              <el-select
                v-model="form.projectId"
                multiple
                filterable
                collapse-tags
                @change="selectAll"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in allPropertyList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item
              label="项目周期"
              prop="period"
              :rules="[{ required: true, message: '请选择周期', trigger: 'blur' }]"
            >
              <el-select
                v-model="form.period"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in periodList"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item>
              <el-button type="primary" @click="onSubmit">立即查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <WebReport ref="WebReport" :url="url" :params="params" :roomName="roomName" :name="name" />
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import urlSettings from '@/config/url-settings';
import WebReport from '@/components/web-report';
import {getprojectlistreport,getperiodlistreport} from "@/api/crmedical/value/value-analysis-report.js";
export default {
  components: {
    WebReport,
  },
  data() {
    return {
      url: '',
      form: {
        projectId: [],
        period: '',
      },
      periodList:[],
      allPropertyList: [],
      oldOptions: [],
      params: {
        reportlet:urlSettings.VUE_APP_ENVIRONMENT +  '/value_analysis.cpt',
        //  reportlet: 'oweSummary.cpt',
      },
      dic: [],
    };
  },
  methods: {
    selectAll(val) {
      let allValues = []; //保留所有值
      let value = []; //保留所选的值

      for (let item of this.allPropertyList) {
        allValues.push(item.id);
      }
      // 用来储存上一次的值，可以进行对比
      const oldVal = this.oldOptions;

      // 若是全部选择
      if (val.indexOf('0000') != -1) {
        value = allValues;
      }

      // 取消全部选中  上次有 当前没有 表示取消全选
      if (oldVal.indexOf('0000') != -1 && val.indexOf('0000') == -1) {
        value = [];
      }

      // 点击非全部选中  需要排除全部选中 以及 当前点击的选项
      // 新老数据都有全部选中
      if (oldVal.indexOf('0000') != -1 && val.indexOf('0000') != -1) {
        if (val.length < allValues.length) {
          const index = val.indexOf('0000');
          val.splice(index, 1); // 排除全选选项
          value = val;
        } else {
          value = val;
        }
      }

      //全选未选 但是其他选项全部选上 则全选选上 上次和当前 都没有全选
      if (oldVal.indexOf('0000') == -1 && val.indexOf('0000') == -1) {
        if (val.length === allValues.length - 1) {
          value = ['0000'].concat(val);
        } else {
          value = val;
        }
      }

      //储存当前最后的结果 作为下次的老数据
      this.oldOptions = value;
      this.form.projectId = value;
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.params.projectId = `(${this.form.projectId.join(',')})`;
          // this.params.period = this.dayjs(this.form.period).format('YYYYMM');
          this.params.period = this.form.period;
          setTimeout(() => {
            this.$refs.WebReport.regroupUrl();
          }, 0);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    initPropertyList() {
      // periodList
      getperiodlistreport().then(res=>{
        this.periodList = res.data;
        this.form.period = this.periodList[0];
      })
      var that = this;
      
      getprojectlistreport({}).then((data) => {
        this.allPropertyList = data.data;
        let obj = {};
        obj.name = '全部';
        obj.id = '0000';
        this.allPropertyList.unshift(obj);
        this.form.projectId.push(this.allPropertyList[1].id);
        this.params.projectId = `(${this.allPropertyList[1].id})`;
        var reportUrl = urlSettings.BASE_REPORT_URL;
        console.log("reportUrl=========>",reportUrl);
        this.url = reportUrl.split('?')[0];
        // this.url = 'http://localhost:8075/WebReport/ReportServer?reportlet=value_analysis.cpt';
        
        setTimeout(() => {
          this.$refs.WebReport.regroupUrl();
        }, 0);
      });
    },
  },

  created() {
    console.log('6666666666666666666666');
        var reportUrl = urlSettings.BASE_REPORT_URL;
        console.log("reportUrl=========>",reportUrl);
    this.initPropertyList();
    // this.params.projectId = `(0)`;
    // this.form.period = new Date();
    // this.params.period = this.dayjs(this.form.period).format('YYYYMM');
    // this.url = reportUrl.split('?')[0];
    // this.url = 'http://localhost:8075/WebReport/ReportServer?reportlet=pmsone%2Fcharge_details.cpt';
  },
};
</script>

<style></style>
